module.exports = __webpack_public_path__ + "e2b3d6a4295d484e40870dff6254c642.svg";